"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
const analytics_node_1 = require("@segment/analytics-node");
class Analytics {
    constructor(writeKey, opts) {
        if (!(writeKey === null || writeKey === void 0 ? void 0 : writeKey.length)) {
            throw new Error("You must pass your June workspace's write key.");
        }
        const options = opts !== null && opts !== void 0 ? opts : {};
        const mergedOptions = Object.assign(Object.assign({}, options), { writeKey, host: "https://api.june.so", path: "/sdk/batch" });
        this.nodeAnalytics = new analytics_node_1.Analytics(mergedOptions);
    }
    identify(params, callback) {
        this.nodeAnalytics.identify(params, callback);
    }
    track(params, callback) {
        this.nodeAnalytics.track(params, callback);
    }
    page(params, callback) {
        this.nodeAnalytics.page(params, callback);
    }
    screen(params, callback) {
        this.nodeAnalytics.screen(params, callback);
    }
    group(params, callback) {
        this.nodeAnalytics.group(params, callback);
    }
    closeAndFlush(timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.nodeAnalytics.closeAndFlush({ timeout });
        });
    }
}
exports.Analytics = Analytics;
